import type { ProjectSweepEvidence } from "../intake/types";

import { diagnoseRepositoryInventory } from "./diagnosticRuleEngine";

import { buildDiagnosticMatrix } from "./diagnosticMatrix";

import { buildDiagnosticChecklist } from "./checklistGenerator";

export class ProjectDiagnosticService {
  diagnose(evidence: ProjectSweepEvidence) {
    const findings = diagnoseRepositoryInventory(evidence.inventory);

    const matrix = buildDiagnosticMatrix(findings);

    const checklist = buildDiagnosticChecklist(findings);

    return {
      evidence,
      matrix,
      checklist,
    };
  }
}
